<ng-container *ngIf="state$ | async as state">

    <h2 mat-dialog-title class="pv-dialog-title">
        <mat-icon class="material-symbols-outlined">description</mat-icon>
        <span class="pv-dialog-title-text">Report Details</span>
        <button mat-icon-button class="pv-dialog-close" (click)="cancel()" matTooltip="Close" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </h2>

    <!-- LOADING: white card loader -->
    <div class="pv-dialog-loading" *ngIf="state.status === 'LOADING'; else readyTpl">
        <pv-spinner message="Loading…" fill="white"></pv-spinner>
    </div>

    <ng-template #readyTpl>
        <mat-dialog-content class="pv-dialog-body">
            <form id="sample_form"
                [formGroup]="formGroup"
                (ngSubmit)="attempt()"
                novalidate
                autocomplete="no">

                <div class="field-block">
                    <label class="field-label">Label</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput type="text" formControlName="label" autocomplete="off">
                        <mat-hint>Label to identify the report</mat-hint>
                        <mat-error>Label required, max 32 characters</mat-error>
                    </mat-form-field>
                </div>

                <div class="field-block">
                    <label class="field-label">Description</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <textarea matInput rows="4" formControlName="description" style="resize: none;"></textarea>
                        <mat-hint>Describe report or contents</mat-hint>
                        <mat-error>Description max 255 chars</mat-error>
                    </mat-form-field>
                </div>
            </form>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="pv-dialog-footer">
            <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
            <button type="button" mat-flat-button color="primary" (click)="attempt()">
                <mat-icon>check</mat-icon>
                Apply
            </button>
        </mat-dialog-actions>
    </ng-template>

</ng-container>
